import { createStore, combineReducers } from 'redux';
import status from './reducer/status';

const rootReducer = combineReducers({
    status
});

const store = createStore(rootReducer);

export default store;